import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import partial from 'lodash/partial';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {formDataManager} from 'hoc/formDataManager';
import {deleteResourceAction} from 'resources/actions';
import {resourcesSelector} from 'resources/selectors';
import DeleteStepsModal from './DeleteStepsModal';
import {endDeleteStepsAction} from '../actions';
import * as ResourceApi from 'api/resources';
import config from './deleteStepsFormConfig';

const mapStateToProps = state => {
  const { deletingSteps, currentPlatform } = state.viewAllPlatforms;
  const modalOpen = deletingSteps;
  const challenge = get(state.editBreak, 'break', null);

  if (!currentPlatform || isEmpty(challenge)) {
    return {
      modalOpen,
      currentPlatform,
      resource: null,
      options: []
    };
  } else {
    const resources = resourcesSelector(state.resources);
    const breakId = challenge[currentPlatform];
    const resource = resources[breakId];

    return {
      modalOpen,
        breakId,
      currentPlatform,
      resource
    };
  }
};

const mapDispatchToProps = dispatch => bindActionCreators({
  deleteSteps: (resource, breakId, data) => deleteResourceAction(ResourceApi.Types.BreakStep, resource, null, [{type: ResourceApi.Types.Break, id: breakId}], [], [], {
          stepIds: data.stepIdsToDelete
  }),
  handleCloseForCurrentPlatform: endDeleteStepsAction
}, dispatch);

const DeleteStepsModalConnected = connect(mapStateToProps, mapDispatchToProps);

const DeleteStepsModalWithHandlers = withHandlers({
  onSaveData: props => partial(props.deleteSteps, props.resource, props.breakId),
  handleClose: props => partial(props.handleCloseForCurrentPlatform, props.currentPlatform)
});

const DeleteStepsModalResourceForm = formDataManager({
  stepIdsToDelete: []
}, config);

const DeleteStepsModalLifecycle = lifecycle({
  componentWillReceiveProps(nextProps) {
    const modalWillClose = this.props.modalOpen && !nextProps.modalOpen;
    if (modalWillClose) {
      this.props.reset();
    }
  }
});

const DeleteStepsModalContainer = compose(
  DeleteStepsModalConnected,
  DeleteStepsModalWithHandlers,
  DeleteStepsModalResourceForm,
  DeleteStepsModalLifecycle
)(DeleteStepsModal);

export default DeleteStepsModalContainer;



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/DeleteSteps/DeleteStepsModalContainer.js